export default "__VITE_PUBLIC_ASSET__5496f0d6__"